"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/AudioFeed.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _log = require('shared/log');






// Class timing is kept: the ref callback is stable, so it runs only when the
// <audio> element mounts or unmounts, never on a re-render (a new callback
// would re-attach the stream and restart playback). The stream comparison and
// the cleanup run in layout effects, like componentDidUpdate and
// componentWillUnmount.
const AudioFeed = ({ stream = null, className }) => {
  const audioDOM = _react.useRef(null)
  // `this.props.stream` for the stable callbacks. An insertion effect runs
  // before React attaches refs, so the ref callback sees this render's stream.
  const latestStream = _react.useRef.call(void 0, stream)
  _react.useInsertionEffect.call(void 0, () => { latestStream.current = stream })
  const prevStream = _react.useRef.call(void 0, stream)

  const cleanup = _react.useCallback.call(void 0, () => {
    if (!audioDOM.current) return
    audioDOM.current.src = ''
    audioDOM.current.load()
  }, [])

  const updateStreamSrc = _react.useCallback.call(void 0, () => {
    const currentStream = latestStream.current
    cleanup()
    if (audioDOM.current && currentStream) {
      audioDOM.current.srcObject = currentStream
      const played = audioDOM.current.play()
      if (played !== undefined) {
        played.catch(e => _log.log.info("Couldn't play audio", e))
      }
    }
  }, [cleanup])

  const initStreamPlayback = _react.useCallback.call(void 0, (r) => {
    audioDOM.current = r
    updateStreamSrc()
  }, [updateStreamSrc])

  // componentDidUpdate
  _react.useLayoutEffect.call(void 0, () => {
    if (prevStream.current === stream) return
    prevStream.current = stream
    updateStreamSrc()
  }, [stream, updateStreamSrc])

  // componentWillUnmount
  _react.useLayoutEffect.call(void 0, () => cleanup, [cleanup])

  const rootClassName = _classBuilder2.default.call(void 0, 
    className, 'meeting--audio-feed',
  )

  return (
    _react2.default.createElement('audio', {
      playsInline: true,
      autoPlay: true,
      className: rootClassName,
      ref: initStreamPlayback, __self: this, __source: {fileName: _jsxFileName, lineNumber: 61}}
    )
  )
}

exports. default = AudioFeed
